import { action, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppProps } from './App';
import { loadNewMbox } from '../stores/appStateStore';

const DropZone = observer((props: AppProps) => {
	const { state, styles } = props;

	const onDrop = async (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();

		styles.get('dropzone').addClass('hidden');

		const dt = e.dataTransfer;
		if (dt.items) {
			// Use DataTransferItemList interface to access the file(s)
			for (let i = 0; i < dt.items.length; i++) {
				if (dt.items[i].kind === 'file') {
					const f = dt.items[i].getAsFile();
					if (f) {
                        loadNewMbox(state, f).then((newMbox) => {
                            if(newMbox) {
                                runInAction(() => {
                                    state.mboxList.push(newMbox);
                                });
                            }
                        });
					}
				}
			}
		} else {
			// Use DataTransfer interface to access the file(s)
			for (let i = 0; i < dt.files.length; i++) {
                loadNewMbox(state, dt.files[i]).then((newMbox) => {
                    if(newMbox) {
                        runInAction(() => {
                            state.mboxList.push(newMbox);
                        });
                    }
                });
			}
		}
	}; // onDrop()

	const onDragLeave = action((e: React.DragEvent<HTMLDivElement>) => {
		styles.get('dropzone').addClass('hidden');
	});

	const onDragStart = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
	};

	const onDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
	};

	return (
		<div
			className={styles.get('dropzone').classNames}
			onDragStart={onDragStart}
			onDragEnter={onDragEnter}
			onDrop={onDrop}
			onDragLeave={onDragLeave}
		>
			<div className="dropzoneText">Drop file here!</div>
		</div>
	);
}); // DropZone()

export default DropZone;
